import { AISummaryType } from '@features/campaigns/performance/types/performance.ts';

export const mockedAISummaryData: AISummaryType = {
  summary: `# Campaign Performance Summary

## Key Metrics
- **Total Impressions**: 1,716,096
- **Unique Devices**: 924,965
- **Average Frequency**: 1.86

## Performance Analysis
The campaign has shown **strong performance** across all key metrics. Impressions peaked on April 11th with 239,784 impressions, indicating effective audience targeting during that period.

### Highlights:
- Consistent daily performance with minimal fluctuations
- High unique device reach suggesting broad audience engagement
- Optimal frequency capping maintaining user experience

## Recommendations
1. **Scale Up**: Consider increasing budget allocation for similar targeting parameters
2. **Time Optimization**: Focus ad delivery during peak performance hours (based on April 11th data)
3. **Creative Refresh**: Maintain current creative strategy as engagement remains high`,
  generationDate: new Date('2024-01-15T10:30:00Z'),
};

export const mockedEmptyAISummaryData: AISummaryType = {
  summary: '',
  generationDate: new Date('2024-01-15T10:30:00Z'),
};

export const mockedGeneratedAISummaryData: AISummaryType = {
  summary: `# Newly Generated Campaign Summary

## Performance Overview
This campaign has been **successfully analyzed** using AI-powered insights.

### Key Findings:
- Strong impression delivery consistency
- Effective audience targeting parameters
- Optimal frequency distribution

## Strategic Insights
The data indicates a well-optimized campaign with room for strategic expansion in similar market segments.`,
  generationDate: new Date('2024-01-15T14:45:00Z'),
};
